import { Box, Typography } from '@mui/material'

import { JudgesSocialNetworks } from './JudgesSocialNetworks'

export const JudgeSocialLinks = ({ judge, handleChange, judgeIndex }) => (
  <Box
    display="flex"
    flexDirection="column"
    gap={1}
  >
    <Typography
      variant="h6"
      color="text.secondary"
      sx={{
        padding: '12px 0',
      }}
    >
      Social networks links
    </Typography>
    <JudgesSocialNetworks
      judge={judge}
      handleChange={handleChange}
    />
  </Box>
)
